export enum NegotiationStatus {
  NotDefined = 0,
  Approve = 1,
  Reject = 2,
  Offer = 3,
}
